module.exports = __webpack_public_path__ + "img/peru-nacion.f80e59ce.png";